import type { AvatarConfig, AvatarField } from './avatar-catalog'
import type { AvatarLayer } from './avatar-custom'

function Layer({ layer: l }: { layer: AvatarLayer }) {
  return (
    <g
      transform={`translate(${l.x} ${l.y}) rotate(${l.rotation} ${l.width / 2} ${l.height / 2})`}
      opacity={l.opacity}
    >
      {l.kind === 'image' ? (
        <image
          href={l.url}
          width={l.width}
          height={l.height}
          preserveAspectRatio="xMidYMid meet"
        />
      ) : l.kind === 'text' ? (
        <text
          x={l.width / 2}
          y={l.height / 2}
          textAnchor="middle"
          dominantBaseline="central"
          fill={l.color}
          fontFamily="sans-serif"
          fontWeight="700"
          fontSize={l.height * 0.75}
          textLength={l.width}
          lengthAdjust="spacingAndGlyphs"
        >
          {l.text}
        </text>
      ) : (
        <g transform={`scale(${l.width / 100} ${l.height / 100})`} fill={l.color}>
          {l.shape === 'circle' && <circle cx="50" cy="50" r="49" />}
          {l.shape === 'rectangle' && <rect width="100" height="100" rx="8" />}
          {l.shape === 'star' && (
            <path d="M50 2 62 35 98 36 70 58 80 95 50 74 20 95 30 58 2 36 38 35Z" />
          )}
          {l.shape === 'heart' && (
            <path d="M50 94C-40 35 15-20 50 18 85-20 140 35 50 94Z" />
          )}
          {l.shape === 'diamond' && <path d="M50 0 100 50 50 100 0 50Z" />}
        </g>
      )}
    </g>
  )
}

export function AvatarCustomLayers({
  config,
  categories,
}: {
  config: AvatarConfig
  categories: AvatarField[]
}) {
  return (
    <>
      {categories
        .flatMap((category) =>
          (config.custom ?? []).filter((p) => p.category === category)
        )
        .map((p) => (
          <g key={p.id} data-avatar-piece={p.id}>
            {p.design.layers.map((layer, index) => (
              <Layer key={index} layer={layer} />
            ))}
          </g>
        ))}
    </>
  )
}
